import type Store from '@ember-data/store';
import { get, set } from '@ember/object';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AdminUser from 'donor-elf-web/models/admin/user';
import type CachedDataset from 'donor-elf-web/services/cached-dataset';
import type FundsService from 'donor-elf-web/services/funds-service';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class AdminUserShowRoute extends Route {
  @service declare cachedDataset: CachedDataset;
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;
  @service declare storeCache: any;
  @service declare store: Store;

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  }

  model(params: any) {
    // if (this.storeCache.modelNameIsCached('admin/user')) {
    //   return this.storeCache
    //     .indexSingleBy('admin/user', 'id')
    //     .then((usersById: any) => usersById[params.id]);
    // } else {
    //   return this.store.findRecord('admin/user', params.id);
    //}

    return this.cachedDataset
      .forModel('admin/user')
      .findById(params.id);
  }

  afterModel(model: AdminUser) {
    if (model == null) {
      this.router.transitionTo('admin.users.index');
    }
    set(this, 'navbarSettings.title', get(model, 'displayName'));
  }
}
